module.exports = __webpack_public_path__ + "img/logo.45b9fd0e.jpg";